import React, { Component, PropTypes } from "react";
import { inject, observer } from "mobx-react";
import Form, { DateInput, FormActions, FormBody, SelectInput } from "../../Form";
import { observable, toJS } from "mobx";
import { analysis as analysisApi } from '../../../actions/api';
import { interpolation as interpolationApi } from '../api';
import moment from "moment";
import Spinner from "../../Spinner";
import DataTable from "../../DataTable";
import Button from "../../Form/Button";
import { getDisplayDate } from "../../../libs/date";
import GraphView from "../../GraphView";
import _ from "lodash";
import FormMultiSelectInput from "../../FormMultiSelectInput";

@inject('stationStore', 'parameterStore', 'qcFlagStore')
@observer
class ManualInterpolationList extends Component {
  static contextTypes = {
    notify: PropTypes.shape().isRequired,
    router: PropTypes.shape().isRequired,
  }

  @observable filters = {
    station_id: '4123',
    parameter_id: '151',
    date_from: moment().subtract(1, 'days').format('YYYY-MM-DDT00:00:00'),
    date_to: moment().add(1, 'days').format('YYYY-MM-DDT00:00:00'),
  }
  @observable items = [];
  @observable isLoading = false;
  @observable isSaving = false;
  @observable selectedItem = null;
  @observable checkAll = true;
  @observable interpolateOptions = [
    { id: 5, label: 'Suspicious', value: true },
    { id: 8, label: 'Missing', value: true },
    { id: 9, label: 'Erroneous', value: true },
  ]

  componentWillMount() {
    const { stationStore, parameterStore, qcFlagStore } = this.props;
    if (!stationStore.isLoading && !stationStore.items.length) stationStore.fetchItems();
    if (!parameterStore.isLoading && !parameterStore.items.length) parameterStore.fetchItems();
    if (!qcFlagStore.isLoading && !qcFlagStore.items.length) qcFlagStore.fetchItems();
  }

  onChange = (e, key) => this.filters[key] = e.target.value;
  onChangeInterpolateFor = option => {
    option.value = !option.value;
    this.items.filter(item => +item.maxFlag.caption === +option.id).forEach(item => item.checked = option.value);
  }

  onView = (e) => {
    e.preventDefault();
    const { notify } = this.context;
    const { qcFlagStore, parameterStore } = this.props;

    const payload = {
      stations: this.filters.station_id,
      parameters: this.filters.parameter_id,
      date_from: this.filters.date_from,
      date_to: this.filters.date_to,
      show_qc: true
    };
    this.isLoading = true;
    this.items = [];
    const interpolationOptions = this.interpolateOptions.filter(item => !!item.value).map(item => item.id);

    analysisApi.fetchMore(payload)
      .then(res => {
        const parameter = _.get(res, '[0].parameters[0]') || {}
        const data = _.get(res, '[0].parameters[0].data') || []
        // .filter((item, i) => ![15, 16, 20].includes(i));

        this.items = data.reduce((acc, o, index) => {
          const flags = qcFlagStore.getProperFlag(o.qc_flag);
          const maxFlag = qcFlagStore.getMaxFlag(o.qc_flag);
          const timeMills = getDisplayDate(o.time, { returnMills: true });

          if (index > 0 && !!parameter.parameter_interval && interpolationOptions.includes(8)) {
            const prevItem = acc[acc.length - 1];
            const intervalMills = parameter.parameter_interval * 60 * 1000;
            if (timeMills - prevItem.timeMills > intervalMills) {
              const missingFlagItem = qcFlagStore.getFlagByCaption(8);
              const noCheckFlagItem = qcFlagStore.getFlagByCaption(0);
              const diff = (timeMills - prevItem.timeMills) / intervalMills;
              for (let i = 1; i < diff; i++) {
                const missingTimeMills = prevItem.timeMills + (intervalMills * i);
                acc.push({
                  index: acc.length + 1,
                  series_id: parameter.series_id,
                  timeMills: missingTimeMills,
                  time: getDisplayDate(missingTimeMills),
                  timeOrig: moment.utc(missingTimeMills).add(diff, '').format('YYYY-MM-DDTHH:mm:ss'),
                  value: null,
                  maxFlag: missingFlagItem,
                  hqc: noCheckFlagItem,
                  qc2: noCheckFlagItem,
                  qc1: missingFlagItem,
                  qc0: noCheckFlagItem,
                  corrected_value: '',
                  flagged: true,
                  checked: true,
                });
              }
            }
          }

          acc.push({
            index: acc.length + 1,
            series_id: parameter.series_id,
            timeMills: getDisplayDate(o.time, { returnMills: true }),
            time: getDisplayDate(o.time),
            timeOrig: o.time,
            value: o.value,
            maxFlag: qcFlagStore.getFlagByCaption(maxFlag),
            hqc: qcFlagStore.getFlagByCaption(flags[0]),
            qc2: qcFlagStore.getFlagByCaption(flags[1]),
            qc1: qcFlagStore.getFlagByCaption(flags[2]),
            qc0: qcFlagStore.getFlagByCaption(flags[3]),
            corrected_value: '',
            flagged: [5, 9].includes(maxFlag),
            checked: interpolationOptions.includes(maxFlag),
          });
          return acc;
        }, [])
      })
      .catch(err => {
        console.log(err);
        notify.error({ message: err.toString() });
      })
      .finally(() => this.isLoading = false);
  }

  onInterpolate = e => {
    e.preventDefault();
    const { qcFlagStore } = this.props;
    const flaggedItems = this.items.filter(item => item.flagged && item.checked);
    flaggedItems.forEach((item) => {
      const neighbours = this.items.filter((n) => !n.flagged && n.index >= item.index - 3 && n.index <= item.index + 3 && n.time !== item.time);
      item.corrected_value = Math.floor(_.meanBy(neighbours, 'value') * 1000) / 1000;
      item.hqc = qcFlagStore.getFlagByCaption(2);
      item.maxFlag = qcFlagStore.getFlagByCaption(2);
    });
  }

  onSave = (e) => {
    e.preventDefault();
    /*
      payload = [{
        id, qc_flag, series_id, time, value
      }]
    */
    const { notify } = this.context;
    const checkItems = this.items.filter(item => item.flagged && item.checked);
    const payload = checkItems.map(item => ({
      series_id: item.series_id,
      time: item.timeOrig,
      value: item.corrected_value,
      qc_flag: `${item.hqc.caption}${item.qc2.caption}${item.qc1.caption}${item.qc0.caption}`,
    }));

    this.isSaving = true;
    interpolationApi.manualObservationUpdate(payload)
      .then(notify.success)
      .catch(notify.error)
      .finally(() => this.isSaving = false);

  }

  onCheckAll = () => {
    this.checkAll = !this.checkAll;
    this.items.forEach(item => {
      if (item.flagged) item.checked = this.checkAll
    });
  }

  _renderGraph = (parameter) => {
    const options = {
      chart: {
        type: 'line',
        zoomType: 'x',
      },
      title: {
        text: '',
      },
      plotOptions: {
        series: {
          animation: false,
        }
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          second: '%H:%M:%S',
          minute: '%H:%M',
          hour: '%H:%M',
          day: '%Y-%m-%d',
          month: '%Y-%m',
          year: '%Y'
        },
      },
      yAxis: {
        title: {
          text: parameter.parameter_unit_symbol,
        },
      },
      tooltip: {
        crosshairs: true,
        shared: true,
      },
      series: [{
        name: parameter.name,
        data: this.items.map(item => [item.timeMills, item.flagged && item.checked && item.corrected_value != '' ? null : item.value]).sort((a, b) => a[0] - b[0]),
      }, {
        name: 'Corrected',
        data: this.items.map(item => [item.timeMills, item.flagged && item.checked && item.corrected_value != '' ? +item.corrected_value : null]).sort((a, b) => a[0] - b[0]),
      }],
    };
    return <GraphView options={options} />
  }

  _renderTable = (parameter) => {
    return <div className="DataTable" style={{ height: "400px", overflow: "auto" }}>
      <table>
        <thead>
          <tr>
            <th><input type='checkbox' checked={this.checkAll} onChange={this.onCheckAll} /></th>
            <th>Time</th>
            <th>Value</th>
            <th>HQC</th>
            {/* <th>QC2</th> */}
            <th>QC1</th>
            {/* <th>QC0</th> */}
            <th>Corrected Value</th>
          </tr>
        </thead>
        <tbody>
          {this.items.map((item, i) => <tr key={i} style={{ backgroundColor: !!item.maxFlag ? `${item.maxFlag.color}3f` : 'unset' }}>
            <td>{item.flagged && <input type='checkbox' checked={item.checked} onChange={(e) => item.checked = e.target.checked} />}</td>
            <td>{item.time}</td>
            <td>{item.value}</td>
            <td>{item.hqc.description}</td>
            {/* <td>{item.qc2.description}</td> */}
            <td>{item.qc1.description}</td>
            {/* <td>{item.qc0.description}</td> */}
            <td>{item.flagged && <input value={item.corrected_value} onChange={(e) => item.corrected_value = e.target.value} style={{ width: '50px' }} />}</td>
          </tr>)}
        </tbody>
      </table>
    </div>
  }

  render() {
    const { stationStore, parameterStore, qcFlagStore } = this.props;

    if (stationStore.isLoading || parameterStore.isLoading || qcFlagStore.isLoading) return <Spinner />;

    const parameter = parameterStore.findById(this.filters.parameter_id);

    return (
      <div>
        <Form>
          <FormBody>
            <SelectInput label='Station' value={this.filters.station_id} options={stationStore.items} fields={{ label: 'name', value: 'id' }} onChange={(e) => this.onChange(e, 'station_id')} />
            <SelectInput label='Parameter' value={this.filters.parameter_id} options={parameterStore.items} fields={{ label: 'name', value: 'id' }} onChange={(e) => this.onChange(e, 'parameter_id')} />
            <DateInput type='datetime-local' label='Date From' value={this.filters.date_from} onChange={(e) => this.onChange(e, 'date_from')} />
            <DateInput type='datetime-local' label='Date To' value={this.filters.date_to} onChange={(e) => this.onChange(e, 'date_to')} />
            <FormMultiSelectInput id='interpolate-for' label='Interpolate For' options={this.interpolateOptions} optionClicked={this.onChangeInterpolateFor} />
          </FormBody>
          <FormActions>
            <Button label='View' onClick={this.onView} isLoading={this.isLoading} />
            <Button label='Interpolate' onClick={this.onInterpolate} />
            <Button label='Save' onClick={this.onSave} isLoading={this.isSaving} />
          </FormActions>
        </Form>
        {!!this.items.length && <div className='rating-curve-table'>
          {this._renderGraph(parameter)}
          {this._renderTable(parameter)}
        </div>}
      </div>
    );
  }
}

export default ManualInterpolationList;


// WEBPACK FOOTER //
// ./src/components/Tools/Interpolation/ManualInterpolationList.js